<section [formGroup]="current_status">
  <mat-radio-group fxLayout="column" fxLayoutGap="8px" required [formControl]="employment_status">
    <mat-label>Employment Details*</mat-label>
    <mat-error class="error" *ngIf="current_status.get('employment_status').dirty &&
                      current_status.get('employment_status').hasError('required')">Required.
    </mat-error>
    <ng-container class="container" *ngFor="let status of statuses.list|async">
      <mat-radio-button
        *ngIf="isOptionAvailable(status)"
        color="primary" [value]="status.alias">
        {{status.name}}
      </mat-radio-button>
      <div class="details" *ngIf="employment_type.value === 'land' && employment_channel.value === 'balik_manggagawa'">
        <bb-career-details *ngIf="current_status.get('employment_status').value === status.alias"></bb-career-details>
        <bb-career-dates *ngIf="current_status.get('employment_status').value === status.alias"></bb-career-dates>
      </div>
      <div class="details"
        *ngIf="(employment_type.value === 'land' && employment_channel.value !== 'balik_manggagawa') || 
          employment_type.value === 'sea'"
      >
        <bb-career-dates *ngIf="current_status.get('employment_status').value === status.alias"></bb-career-dates>
      </div>
    </ng-container>
  </mat-radio-group>
</section>
